import { Component, ElementRef, OnInit, ViewChild, Input} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { DatePipe } from '@angular/common';
import { forkJoin, Observable, of, Subscription, empty } from "rxjs";
import { filter, map, mergeMap, tap } from "rxjs/operators";
//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";


import { dateComparator } from '../../../common/components/data-table/comparators/data-table.comparators';
import { RouterLinkRendererComponent } from '../../../common/components/ag-grid/router-link-renderer.component';
import { ModalInfoComponent } from "../../../common/components/ag-grid/modal-info.component";
import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { RegistrationRequestService } from '../../../common/services/registration-request.service';
import { AuthService } from "../../../services/auth.service";
import { WorkOrderStatus, WorkOrderType } from '../../../common/models/work-order.model';
import { ViewBase } from "../widgets/view-base";
import { LunaClaimValues, UserIdentity } from '../../../models/user-identity.model';

import { ContactStub, Contact } from "../../../admin/models/contact.model";
import { Group } from "../../../admin/models/group.model";
import { GroupSearchSpec, GroupService } from "../../../admin/services/group.service";
import { FlowIndex } from '../../../common/models/flow.dto';
import { OrganizationStub } from '../../../common/models/organization.model';
import { PendingWorkOrderAssignment } from '../../../common/models/work-order.model';
import { DateService } from '../../../common/services/date.service';
import { WorkOrderService } from '../../../common/services/work-order.service';
import { PendingFlow, State } from '../../../flow/models/flow.model';
import { FlowIndexSpec, FlowInstanceService } from '../../../flow/services/flow-instance.service';



@Component({
    selector: 'registration-request',
    templateUrl: './registration-request.component.html',
    standalone: false
})
export class RegistrationRequestComponent extends ViewBase implements OnInit {
    @Input() widgetTitle: string;


    data: Observable<any>;
    gridOptions: GridOptions;
    subscriptions: Subscription = new Subscription();
    orgStubs: OrganizationStub[];
    showingDetail: boolean = false;
	firstReviewGridOptions: GridOptions;
	firstReviewGridApi?: GridApi;
	finalReviewGridOptions: GridOptions;
	finalReviewGridApi?: GridApi;
    firstPendingFlows: PendingFlow[];
    finalPendingFlows: PendingFlow[];
    groupHasPermission: any;
    allUsers: ContactStub[] = [];
    groups: Group[] = [];
    firstFilteredUsers: ContactStub[] = [];
    finalFilteredUsers: ContactStub[] = [];
    selectedItem: any;

    constructor(
        public registrationService: RegistrationRequestService,
        public datePipe: DatePipe,
        private formatterService: GridFormatterService,
        private router: Router,
        public groupService: GroupService,
        public workOrderService: WorkOrderService,
        public gridFormatterService: GridFormatterService,
        public authService: AuthService,
        public dateService: DateService,
    ) {
        super("ViewRegistrationRequestWidget", [LunaClaimValues.ViewRegistrationRequestWidget]);
    }

    ngOnInit(): void {
        this.refreshData();
        this.setGridOptions();
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    columnDateColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Date",
        headerTooltip: "Date",
        comparator: dateComparator,
        field: "createdDate",
        tooltipValueGetter: this.formatterService.formatDate("createdDate"),
        valueGetter: this.formatterService.formatDate("createdDate"),
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        sort: "desc",
        sortingOrder: ["asc", null, "desc"],
        minWidth: 125,
        maxWidth: 125
    }

    columnApplicationNumberColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        field: "applicationNumber",
        tooltipField: "applicationNumber",
        filter: "agTextColumnFilter",
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: { textField: "applicationNumber" },       
        minWidth: 135,
        maxWidth: 150
    }

    columnTitleColumn: ColDef = {
        headerClass: "wrapped",
        editable: false,
        headerName: 'Application Type',
        headerTooltip: 'Application Type',
        field: 'name',
        tooltipField: 'name',
        minWidth: 150,
        maxWidth: 200,
        filter: "agTextColumnFilter"
    }

    columnStatusColumn: ColDef = {
        headerClass: "wrapped",
        headerName: 'Status',
        headerTooltip: 'Status',
        field: 'status',
        tooltipField: 'status',
        filter: "agTextColumnFilter",
        minWidth: 125,
        maxWidth: 150
    }

    columnCompanyNameColumn: ColDef = {
        headerClass: "wrapped",
        headerName: 'Company Name',
        headerTooltip: 'Company Name',
        field: "companyName",
        tooltipField: "companyName",
        filter: "agTextColumnFilter",
        minWidth: 150,
        maxWidth: 200
    }

    firstReviewColumns: ColDef[] = [
        this.columnDateColumn,
        this.columnApplicationNumberColumn,
        this.columnTitleColumn,
        this.columnStatusColumn,
        this.columnCompanyNameColumn,
    ];

    finalReviewColumns: ColDef[] = [
        this.columnDateColumn,
        this.columnApplicationNumberColumn,
        this.columnTitleColumn,
        this.columnStatusColumn,
        this.columnCompanyNameColumn,
    ];

    assign(params: any): any {
        let result: boolean = false;
        if (params && params.newValue && params.newValue.id) {
            if (params.newValue.id != "-1") {
                params.data.assignedUserId = params.newValue.id;
            } else {
                params.data.assignedUserId = "";
            }

            if (params.context && params.context.componentParent) {
                let parent = <RegistrationRequestComponent>params.context.componentParent;
                let selectedItem = parent.allUsers.find(u => u.id == params.newValue.id);
                if (selectedItem) {
                    params.data.assignedUserName = selectedItem.displayName;
                }
            }
            result = true;
        }
        return result;
    }
    buildFirstColumns(): ColDef[] {
        let colDefs: ColDef[] = [];
        colDefs.push(this.columnDateColumn);
        colDefs.push(this.columnApplicationNumberColumn);
        colDefs.push(this.columnTitleColumn);
        colDefs.push(this.columnStatusColumn);
        colDefs.push(this.columnCompanyNameColumn);
        colDefs.push({
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.firstFilteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140,
            maxWidth: 150
        } as ColDef);
        this.formatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }

    buildFinalColumns(): ColDef[] {
        let colDefs: ColDef[] = [];
        colDefs.push(this.columnDateColumn);
        colDefs.push(this.columnApplicationNumberColumn);
        colDefs.push(this.columnTitleColumn);
        colDefs.push(this.columnStatusColumn);
        colDefs.push(this.columnCompanyNameColumn);
        colDefs.push({
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.finalFilteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 140,
            maxWidth: 150
        } as ColDef);
        this.formatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }

    cellValueChanged(params: any): void {
        if (params.api) {
            params.api.refreshCells();
        }
    }

    getDataObs$(): Observable<[PendingFlow[], PendingFlow[]]> {
        this.showLoadingOverlays(true);

        let allUserSearchObs$ = this.groupService.get({ internal: true, stubs: false, fullContactDetails: true } as GroupSearchSpec);

        let firstSearchObs$ = this.workOrderService.getPendingFlowsByTargetTransition("AllRegistrationLevel1WorkOrders").pipe(tap((regsFirst: PendingFlow[]) => {
            this.firstPendingFlows = regsFirst;
        }));
        let finalSearchObs$ = this.workOrderService.getPendingFlowsByTargetTransition("AllRegistrationLevel2WorkOrders").pipe(tap((regsFinal: PendingFlow[]) => {
            this.finalPendingFlows = regsFinal;
        }));
        let level1Subs$ = allUserSearchObs$.pipe(mergeMap((groupData) => {
            this.allUsers = [];
            this.firstFilteredUsers = [];
            this.finalFilteredUsers = [];
            if (groupData) {
                if (groupData instanceof Array) {
                    this.groups = groupData as Group[];
                    this.groups.forEach(g => this.allUsers = this.allUsers.concat(g.users));
                }
                this.allUsers = this.filterUniqueUsers(this.allUsers);
                this.allUsers.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
            }
            return forkJoin(firstSearchObs$, finalSearchObs$);
        }))
        return level1Subs$;
    }

    buildUserList(groups: Group[]): ContactStub[] {
        let userList: ContactStub[] = [];
        groups.forEach(u => userList = userList.concat(u.users));
        userList = this.filterUniqueUsers(userList);
        userList = this.sortUsers(userList);
        userList.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
        return userList;
    }

    filterUniqueUsers(users: ContactStub[]): ContactStub[] {
        return users.filter((user, i, arr) => arr.findIndex(t => t.id === user.id) === i);
    }


    refreshData(): void {

        let subs$ = this.getDataObs$().pipe(
            map(([level1Rows, level2Rows]) => {
                let level1Groups = this.groups.filter(g => this.groupHasPermission(g));
                this.firstFilteredUsers = this.buildUserList(level1Groups);
                let level2Groups = this.groups.filter(g => this.groupHasPermission(g));
                this.finalFilteredUsers = this.buildUserList(level2Groups);
            })
        ).subscribe(
            { next: () => {
                if (this.firstReviewGridApi != null) {
                    this.firstReviewGridApi.setGridOption("columnDefs", []);
                    this.firstReviewGridApi.setGridOption("columnDefs", this.buildFirstColumns());
                }
                if (this.finalReviewGridApi != null) {
                    this.finalReviewGridApi.setGridOption("columnDefs", []);
                    this.finalReviewGridApi.setGridOption("columnDefs", this.buildFinalColumns());
                }                
                this.showLoadingOverlays(false);
            }, error: (error) => {
                console.error(error);
            }
        });
        this.subscriptions.add(subs$);
    }

    renderUserDropdownOptions(params: any): string {
        let returnValue = params && params.value && params.value.displayName ? params.value.displayName : "Unassigned";
        return returnValue;
    }

    renderAssignedUser(params: any): string {
        let returnValue: string = "Unassigned";
        if (params && params.data && params.data.assignedUserId && params.data.assignedUserName) {
            returnValue = params.data.assignedUserName;
        }
        return returnValue;
    }

    saveAssignments(event: any): void {
        let changedItem = <PendingFlow>event.data;
        if (event.context && event.context.componentParent) {
            const component = <RegistrationRequestComponent>event.context.componentParent;
            const pending = new PendingWorkOrderAssignment(changedItem.currentWorkItemId, changedItem.assignedUserId, changedItem.assignedUserName, true, changedItem.flowId);
            let updateSubs$ = component.workOrderService.assignWorkOrder(pending).pipe()
                .subscribe({
                    next: (result) => { console.log("update managed"); },
                    error: (error) => { console.error(error); }
            });
            component.subscriptions.add(updateSubs$);
        }
    }

    setGridOptions(): void {
        this.firstReviewGridOptions = <GridOptions>{
            columnDefs: this.buildFirstColumns(),
            context: {
                componentParent: this
            },
            defaultColDef: { filter: true, resizable: true, sortable: true, editable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            onCellValueChanged: ($event) => this.saveAssignments($event),
            pagination: true,
            paginationAutoPageSize: true,
			suppressHorizontalScroll: false,
			onGridReady: (params) => { this.firstReviewGridApi = params.api; },
            headerHeight: 50
        };
        this.finalReviewGridOptions = <GridOptions>{
            columnDefs: this.buildFinalColumns(),
            context: {
                componentParent: this
            },
            defaultColDef: { filter: true, resizable: true, sortable: true, editable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            onCellValueChanged: ($event) => this.saveAssignments($event),
            pagination: true,
            paginationAutoPageSize: true,
			suppressHorizontalScroll: false,
			onGridReady: (params) => { this.finalReviewGridApi = params.api; },
            headerHeight: 50
        };
    }

    showLoadingOverlays(show: boolean): void {
        if (this.firstReviewGridApi) {
            if (show) {
                this.firstReviewGridApi.setGridOption("rowData", []);
                this.firstReviewGridApi.setGridOption("loading", true)
            } else
                this.firstReviewGridApi.setGridOption("loading", false);
        }
        if (this.finalReviewGridApi) {
            if (show) {
                this.finalReviewGridApi.setGridOption("rowData", []);
                this.finalReviewGridApi.setGridOption("loading", true);
            } else
                this.finalReviewGridApi.setGridOption("loading", false);
        }
    }

    sortUsers(users: ContactStub[]): ContactStub[] {
        return users.sort((a, b) => {
            if (a.firstName > b.firstName) return 1;
            if (a.firstName < b.firstName) return -1;
            if (a.firstName == b.firstName) {
                if (a.lastName > b.lastName) return 1;
                if (a.lastName < b.lastName) return -1;
            }
            return 0;
        })
    }

    onTabClicked(): void {
        if (this.firstReviewGridApi != null) {
            this.firstReviewGridApi.sizeColumnsToFit();
        }
        if (this.finalReviewGridApi != null) {
            this.finalReviewGridApi.sizeColumnsToFit();
        }
        
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    sortFlowIndices(indices: FlowIndex[]): FlowIndex[] { //sort by date submitted if available, then by created date if not
        return indices.sort((a, b) => {
            if (a.dateSubmitted < b.dateSubmitted) return -1;
            if (a.dateSubmitted > b.dateSubmitted) return 1;
            if (a.createdDate < b.createdDate) return -1;
            if (a.createdDate > b.createdDate) return 1;
            return 0;
        });
    }
}
